export default function defaultactions(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        defaultaction: action.defaultaction,
      }
    default:
      return state;
  }
}
